import React, { useEffect, useState, useRef } from "react";
import "./Address.css";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  InfoWindow,
  Marker,
} from "react-google-maps";
import Autocomplete from "react-google-autocomplete";
import Geocode from "react-geocode";
import { connect } from "react-redux";
import { getMapMyIndiaAccessToken } from "../../Redux/Actions";
import axios from "axios";
import { GrFormClose } from "react-icons/gr";

Geocode.setApiKey("AIzaSyBPjDlsHYhWtjt3FxgRPnTMXN-qJZ9hz0s");
Geocode.enableDebug();

function Address(props) {
  const { closeHandler, setPatientMapAddress, closeModel } = props;

  // console.log("close funnction", closeMOdel);
  const byUser = useRef("");

  const [address, setAddress] = useState("");
  const [markerLat, setMarkerLat] = useState(28.6117);
  const [markerLng, setMarkerLng] = useState(77.377);
  const [defaultLat, setDefaultLat] = useState(28.6117);
  const [defaultLng, setDefaultLng] = useState(77.377);

  ///
  const [userLocation, setUserlocation] = useState("");
  const [userCity, setUserCity] = useState("");
  const [displayCityList, setDisplay] = useState(false);
  const [cityList, setCityList] = useState([]);

  const setInputcity = (val) => {
    setUserCity(val);
    setDisplay(false);
  };

  const onPlaceSelected = (place) => {
    const mapAddress = place.formatted_address;
    const latValue = place.geometry.location.lat();
    const lngValue = place.geometry.location.lng();
    setAddress(mapAddress);
    setPatientMapAddress(mapAddress);
    setMarkerLat(latValue);
    setMarkerLng(lngValue);
    setDefaultLat(latValue);
    setDefaultLng(lngValue);
  };

  const onMarkerDragEnd = (event) => {
    console.log("event", event);
    let newLat = event.latLng.lat(),
      newLng = event.latLng.lng(),
      addressArray = [];
    Geocode.fromLatLng(newLat, newLng).then(
      (response) => {
        const mapAddress = response.results[0].formatted_address;
        setAddress(mapAddress);
        setPatientMapAddress(mapAddress);
      },
      (error) => {
        console.error(error);
      }
    );
  };

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal.token;
    props.getMapMyIndiaAccessToken(token);
  }, []);

  const locationAutoCompleteSearch = (e) => {
    console.log(e, "eeeeee");
    if (
      !props.LoadingAccessToken &&
      e.target.value?.length > 2 &&
      e.nativeEvent.data != null
    ) {
      setCityList([]);
      const urlForMap = `https://atlas.mapmyindia.com/api/places/search/json?query=${e.target.value}&access_token=${props.Accesstoken}&tokenizeAddress=true`;
      axios
        .get(urlForMap)
        .then((res) => {
          res.data.suggestedLocations.map((item) => {
            setCityList((lst) => [...lst, item.placeAddress]);
            console.log(cityList);
            console.log(item.placeAddress);
          });
        })
        .catch((err) => {
          console.log(err);
        });
      // console.log(e.target.value,data,"Here is value")
      setDisplay(true);
    } else {
      setDisplay(false);
    }
    setUserCity(e.target.value);
  };

  useEffect(() => {
    if (cityList.length == 0 || userCity == "") {
      setDisplay(false);
    } else {
      setDisplay(true);
    }
  }, [cityList]);

  //
  const selectLocation = (e) => {
    // console.log("form e", e);
    console.log("by user location ", byUser.current?.value);
    const locaUser = byUser.current?.value;
    const userCompleteLocation = `${locaUser}  ${userCity}`;
    setPatientMapAddress(userCompleteLocation);
    closeModel();
  };
  const onInfoWindowClose = (event) => {};
  const AsyncMap = withScriptjs(
    withGoogleMap((props) => (
      <GoogleMap
        google={props.google}
        defaultZoom={8}
        defaultCenter={{
          lat: defaultLat,
          lng: defaultLng,
        }}
      >
        {/* For Auto complete Search Box */}

        {/*Marker*/}
        {/* <Marker
          google={props.google}
          name={"Redcliffe Labs"}
          draggable={true}
          onDragEnd={onMarkerDragEnd}
          position={{
            lat: markerLat,
            lng: markerLng,
          }}
        />
        <Marker /> */}

        <InfoWindow
          onClose={onInfoWindowClose}
          position={{
            lat: markerLat + 0.0018,
            lng: markerLng,
          }}
        >
          <div>
            {/* <span style={{ padding: 0, margin: 0 }}>
              {address || "Redcliffe Labs"}
            </span> */}

            <Marker
              google={props.google}
              name={"Redcliffe Labs"}
              draggable={true}
              onDragEnd={onMarkerDragEnd}
              position={{
                lat: markerLat,
                lng: markerLng,
              }}
            >
              {address || "Redcliffe Labs"}
            </Marker>
          </div>
        </InfoWindow>
      </GoogleMap>
    ))
  );

  return (
    <div className="mapDress">
      <div className="float__icon addressModalCrossBtn">
        <GrFormClose onClick={() => closeModel()} />
      </div>

      <div className="map" style={{ height: "250px", width: "100%" }}>
        {/* <AsyncMap
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBPjDlsHYhWtjt3FxgRPnTMXN-qJZ9hz0s&libraries=places"
          loadingElement={<div style={{ height: `100px` }} />}
          containerElement={<div style={{ height: "500px" }} />}
          mapElement={<div style={{ height: `400px` }} />}
        /> */}
        <div className="uppperDiv">
          <form onSubmit={selectLocation} className="location__map">
            <label>Your Location</label>
            {/* <Autocomplete               
                  onPlaceSelected={onPlaceSelected}
                  defaultValue={address}
                  types={["(regions)"]}
                  options={{
                    types: ["(regions)"],
                    componentRestrictions: { country: "in" },
                  }}
                  debounce={1000}
                /> */}
            <div>
              <input
                type="text"
                placeholder="Enter City"
                onChange={locationAutoCompleteSearch}
                value={userCity}
                required
              />
              <div
                className={
                  displayCityList ? "cityList cityListAddress" : "displayNone"
                }
                id="cityList"
              >
                {userCity && cityList != []
                  ? cityList.map((values, index) => {
                      return (
                        <>
                          <div
                            onClick={() => setInputcity(values)}
                            key={index}
                            className={
                              displayCityList
                                ? "cityLIstLP cityListLPAddress"
                                : "displayNone"
                            }
                          >
                            <span>{values}</span>
                          </div>
                        </>
                      );
                    })
                  : null}
              </div>
            </div>
            <div className="location__map">
              <label>House No / Floor No.</label>
              <div>
                <input
                  required
                  type="text"
                  ref={byUser}
                  placeholder="Ex: 32, Raj Nagar, Ghaziabad"
                ></input>
                <span className="error"></span>
              </div>
            </div>
            <button
              className="submitBtnAddress"
              // onClick={ ()=> selectLocation()}
              type="submit"
            >
              Update
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  Accesstoken: state.mapMyindiaToken.accesstoken,
  LoadingAccessToken: state.mapMyindiaToken.loading,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getMapMyIndiaAccessToken: (token) => {
      dispatch(getMapMyIndiaAccessToken(token));
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(Address));
